export default "__VITE_ASSET__NwiMV$Ug__"